export default "__VITE_ASSET__RA9CvdRf__"